import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { EditModeMenuItem } from '@imagise/entities';
import { TranslateModule } from '@ngx-translate/core';

export interface EditModeHelpDialogData {
  modeInfo: EditModeMenuItem;
}

@Component({
  selector: 'lib-edit-mode-help-dialog',
  imports: [MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './edit-mode-help-dialog.component.html',
  styleUrl: './edit-mode-help-dialog.component.scss',
})
export class EditModeHelpDialogComponent {
  readonly data = inject<EditModeHelpDialogData>(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<EditModeHelpDialogComponent>);

  public static open(
    dialog: MatDialog,
    modeInfo: EditModeMenuItem,
  ): MatDialogRef<EditModeHelpDialogComponent> {
    return dialog.open(EditModeHelpDialogComponent, {
      data: { modeInfo },
      width: '680px',
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: 'calc(100vh - 32px)',
      panelClass: 'editor-mode-help-dialog',
      autoFocus: false,
    });
  }
}
